import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { log } from 'log';
import { useLiveGamesSelector } from 'js/store/hooks';

export const useLiveGamesConnectWS = () => {
    const dispatch = useDispatch();
    const { socket, isNeedToStart, isSocketConnected } = useLiveGamesSelector(pick(['socket', 'isNeedToStart', 'isSocketConnected']));

    useEffect(() => {
        (async () => {
            if (socket && isNeedToStart && !isSocketConnected) {
                try {
                    await socket.createConnection();
                } catch {
                    log('error', '[LIVE | Portal] WebSocket connection can\'t be opened');
                }
            }
        })();
    }, [socket, dispatch, isNeedToStart, isSocketConnected]);
};
